const NewProducts = [
  {
    id: "5",
    title: "خرس قطبی ماداگاسکاری",
    desc:
      "عروسک فضایی راشل یه جذاب و مهربونه که به تازگی به فروشگاه عروسکی اومده! عروسک خرس راشل انقدر نرم و لطیفه که از بغل کردن و لمس کردنش خسته نمی‌شید عروسک خرس راشل در دو رنگ متفاوت و پرطرفدار موجود شده است که شما می‌توانید با توجه به سلیقه خود رنگ مورد علاقه خود را انتخاب کنید. عروسک خرس بنفش راشل با یه چشمک زیبا دلت رو میبره و رنگ کرم این عروسک با چشم های باز و معصومش نگاهت میکنه. این عروسک خرس میتونه یه رفیق خوب باشه",
    price: 23000,
    image: "https://s19.picofile.com/file/8439995084/4.png",
    text:
      "تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است. تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است.",
  },
  {
    id: "6",
    title: "عروسک عمو پورنگ",
    desc:
      "عروسک فضایی راشل یه جذاب و مهربونه که به تازگی به فروشگاه عروسکی اومده! عروسک خرس راشل انقدر نرم و لطیفه که از بغل کردن و لمس کردنش خسته نمی‌شید عروسک خرس راشل در دو رنگ متفاوت و پرطرفدار موجود شده است که شما می‌توانید با توجه به سلیقه خود رنگ مورد علاقه خود را انتخاب کنید. عروسک خرس بنفش راشل با یه چشمک زیبا دلت رو میبره و رنگ کرم این عروسک با چشم های باز و معصومش نگاهت میکنه. این عروسک خرس میتونه یه رفیق خوب باشه",
    price: 23000,
    image: "https://s19.picofile.com/file/8439995084/4.png",
    text:
      "تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است. تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است.",
  },
  {
    id: "7",
    title: "موشک فضایی چوبی",
    desc:
      "عروسک فضایی راشل یه جذاب و مهربونه که به تازگی به فروشگاه عروسکی اومده! عروسک خرس راشل انقدر نرم و لطیفه که از بغل کردن و لمس کردنش خسته نمی‌شید عروسک خرس راشل در دو رنگ متفاوت و پرطرفدار موجود شده است که شما می‌توانید با توجه به سلیقه خود رنگ مورد علاقه خود را انتخاب کنید. عروسک خرس بنفش راشل با یه چشمک زیبا دلت رو میبره و رنگ کرم این عروسک با چشم های باز و معصومش نگاهت میکنه. این عروسک خرس میتونه یه رفیق خوب باشه",
    price: 23000,
    image: "https://s19.picofile.com/file/8439995084/4.png",
    text:
      "تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است. تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است.",
  },
  {
    id: "8",
    title: "قطار چوبی",
    desc:
      "عروسک فضایی راشل یه جذاب و مهربونه که به تازگی به فروشگاه عروسکی اومده! عروسک خرس راشل انقدر نرم و لطیفه که از بغل کردن و لمس کردنش خسته نمی‌شید عروسک خرس راشل در دو رنگ متفاوت و پرطرفدار موجود شده است که شما می‌توانید با توجه به سلیقه خود رنگ مورد علاقه خود را انتخاب کنید. عروسک خرس بنفش راشل با یه چشمک زیبا دلت رو میبره و رنگ کرم این عروسک با چشم های باز و معصومش نگاهت میکنه. این عروسک خرس میتونه یه رفیق خوب باشه",
    price: 23000,
    image: "https://s19.picofile.com/file/8439995084/4.png",
    text:
      "تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است. تمام اجزای عروسک خرس راشل نرم است و برای بازی بچه ها در سنین پایین هیچ مشکلی ندارد. عروسک خرس راشل چیچیلاس وارداتی، اورجینال و باکیفیت بالا است.",
  },
];
export default NewProducts;
